import React from "react";
const GroupItem = ({ name, forCategory, onClick, level }) => {
  let imgSrc = window.cdn(
    `img/sb-theme/groups/${forCategory}/${name
      .trim()
      .replace(/\s+/g, "-")
      .replace("/", "-")
      .replace("(", "")
      .replace(")", "")
      .toLowerCase()}.png`
  );
  return (
    <div onClick={onClick} style={{ padding: "10px" }} className="sb-hoverable">
      <div>
        {level == 2 && (
          <div>
            <img src={imgSrc} />
          </div>
        )}
        <h4>{name}</h4>
      </div>
    </div>
  );
};

export default GroupItem;
